<template>
    <v-select  
       :value="selected_husttypes"      
       v-model="selectedhusttypes"
       v-bind:items="husttypes"
       item-value="code" 
       item-text="description" 
       :label="label"
       :dense="isDense"
       :clearable="isClearable"
       :multiple="isMultiple"
       @change="updateData()"
       v-on:click:clear="callClear()">
       <template v-slot:prepend-item>
            <v-list-item ripple @mousedown.prevent @click="toggle">
                <v-list-item-action>
                    <v-icon :color="selectedhusttypes.length > 0 ? 'indigo darken-4' : ''"> {{ getIcon() }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Select All</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-2"></v-divider>
        </template>       
        <template v-slot:selection="{ item, index }">
            <v-chip small v-if="index >= 0 && index < visibleChips">
                <span>{{ item.code }}</span>
            </v-chip>
            <span v-if="index === visibleChips" class="grey--text text-caption">(+{{ selectedhusttypes.length - visibleChips }})</span>
        </template>                                                        
     
    </v-select>
</template>

<script>
export default {
    props: {
        selected_husttypes: {
            type: Array,
            default: function() { return []; },
        },
        label: {
            type: String,
            default: 'Status'
        },   
        field: {
            default: 'hustCodesSelected',
            required: true,
        },
        isClearable:{
            type: Boolean,
            default: false
        },
        isDense: {
            type: Boolean,
            init: false
        },
        isMultiple:{
            type: Boolean,
            default: true
        },  
        visibleChips:{
            type: Number,
            default: 12
        },
        localStorageItem:{
            type: String,
            default: 'search.huov.hustcodes'
        }
    },    
    data() {
        return {
            husttypes: [],
            selectedhusttypes: [],
        }
    },
    created() {
        this.getHustCodes();
    },
    methods: {
        callClear(){
            this.selectedhusttypes = [];
        },
        getIcon: function () {
            if (this.isAllSelected()) return 'mdi-close-box'
            if (this.isSomeSelected()) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },    
        isAllSelected: function () {
            return this.selectedhusttypes.length === this.husttypes.length; 
        },
        isSomeSelected: function () {            
            return this.selectedhusttypes.length > 0 && this.selectedhusttypes.length !== this.husttypes.length;
        },   
        toggle() {
            this.$nextTick(() => {
                if (this.isAllSelected()) {
                    this.selectedhusttypes = [];
                    this.updateData();
                } else {
                    this.selectAll();
                    this.updateData();
                }
            })
        },                 
        getHustCodes() {
            this.$axios
                .post("ares/json/ares/huov/hust/getHust.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "getHust"
                    }
                })
                .then(res => {
                    if (res.data.error) {
                        this.showDialog('error', 'Error', res.data.error.message);
                    } else {
                        this.husttypes = res.data.getHust;
                        if(localStorage.getItem(this.localStorageItem)!==null){
                           this.selectedhusttypes=localStorage.getItem(this.localStorageItem).split(",");
                        } else {
                           this.selectAll();
                        }
                        this.updateData();
                    }
                })
        },
        selectAll(){
            this.selectedhusttypes = [];
            this.husttypes.forEach(x => {
                this.selectedhusttypes.push(x.code);
            });
        }, 
        updateData(){              
            this.$emit('updateData', { "field": this.field, "value": this.selectedhusttypes })
        } 
    }
}
</script>

<style scoped>

</style>